/* eslint-disable no-unused-expressions */
import React from 'react';
import './ManageList.css';
import {store} from '../../Redux/Store/Store';
import * as actionsProg from '../../Redux/Actions/Programs';
import * as actions from '../../Redux/Actions/Lists';
import * as httpService from '../HttpService/HttpService';
import {QuestionListDto} from '../Dtos/QuestionListDto';
import * as PropertyBucket from '../../Properties/Properties.js';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Waiter} from '.././WaitingSign/Waiting';
import PopUp from '.././PopUp/PopUp';
import {getTablePageBaseOnPageNumber} from '../../Helpers/utils';
import SelectCustom from '../SelectCustom/SelectCustom';
import TableCustom from '../TableCustom/TableCustom';

class SearchList extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isWaiting: false,
			showPopup: false,
			tablePageSize: 10,
			columns: [
				{title: 'Kod listy', field: 'code', width: 140, customSort: (a, b) => this.sortByCode(a, b)},
				{title: 'Nazwa listy', field: 'name', minWidth: 240, customSort: this.sortingFunction},
				{title: 'Aktywna', field: 'activeString', width: 160}
			],
		};
		this.programmsListSelectRef = React.createRef();
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
		this.changeActivation = this.changeActivation.bind(this);
	}

	sortingFunction(a,b) {
		return a.name.localeCompare(b.name)
	}


	componentDidMount() {
		document.title = "e-Kontrole | Listy sprawdzające";
		const {fetchListsData, fetchProgsData} = this.props;
		fetchListsData();
		fetchProgsData();
	}

	sortByCode(a, b) {
		if(a.code.split('.')[0] < b.code.split('.')[0]) 
		{ return -1; }
    	if(a.code.split('.')[0] > b.code.split('.')[0]) 
		{ return 1; }
		else {
			if(parseInt(a.code.split('.')[1]) < parseInt(b.code.split('.')[1])) {
				return -1
			}
			else if(parseInt(a.code.split('.')[1]) > parseInt(b.code.split('.')[1])) {
				return 1
			}
		}
		return 0;
	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	setValues = (values) => {
		let listData = store.getState().lists.lists;

		if (values.length > 0) {
			listData = listData.filter((el) => {
				return values.some((f) => {
					return f.code.toUpperCase() === el.code.substring(0, 4) || f.code.toUpperCase() === el.code.substring(0, 2);
				});
			});
		}

		this.setState({
			listData: listData
		})
	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	showPopup = (title, notification, type) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type}
		})

	};

	changeActivation = (record) => {
		let _this = this;
		this.isWaitingOnOff(true);
		let listId = record.listId;
		let url = PropertyBucket.urlChangeActivationList(listId);
		let questionListDto = new QuestionListDto();
		questionListDto.listId = listId;
		let messageActive;
		if (record.active === true) {
			questionListDto.active = false;
			messageActive = PropertyBucket.getDeactivateListMessage();
		} else {
			questionListDto.active = true;
			messageActive = PropertyBucket.getActivateListMessage();
		}


		let callPromise = httpService.getServicePromise(url, 'PUT', questionListDto);


		callPromise.then(
			function (message) {
				_this.props.fetchListsData();
				_this.isWaitingOnOff(false);
				_this.showPopup('Komunikat', messageActive, 'notify')
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error, 'error')
			}
		)
	};

	createCopy = (row) => {
		this.props.history.push(
			'/manage_lists/copy_list/' + row.listId
		)
	};

	onEditButtonClick = (row) => {
		let listId = row.listId;
		let url = PropertyBucket.getControlsExistByList(listId);
		let callPromise = httpService.getServicePromise(url, 'GET');
		let _this = this;

		callPromise.then(
			function (message) {
				message === true ?
					_this.showPopup('Błąd', PropertyBucket.getCantEditListMessage(), 'error')
					: _this.props.history.push(
						'/manage_lists/edit_list/' + row.listId
					) 

			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error, 'error')
			}
		)
	};

	onDeactivateButtonClick = (row) => {
		this.setState({
			showPopup: true,
			record: row,
			popUp: {
				title: 'Zmiana statusu',
				notification: row.active === true ? 'Czy chcesz dezaktywować listę ' + row.code + '?' : 'Czy chcesz aktywować listę ' + row.code + '?',
				type: 'confirm',
				onClickEvent: () => {
					this.changeActivation(this.state.record)
				}
			}
		})
	};

	onListPreviewButtonClick = (row) => {
		this.props.history.push(
			'/manage_lists/list_detail/' + row.listId
		) 
	};

	onCopyCreateButtonClick = (row) => {
		this.setState({
			showPopup: true,
			record: row,
			popUp: {
				title: 'Tworzenie kopii listy',
				notification: 'Czy chcesz utworzyć kopię listę ' + row.code + '?',
				type: 'confirm',
				onClickEvent: () => {
					this.createCopy(this.state.record)
				}
			}
		})
	};

	getActiveString = (item) => {
		item.active === true ? item.activeString = 'Tak' : item.activeString = 'Nie';
		return item;
	};

	prepareData = (data) => {
		return data.map(this.getActiveString);
	};
	
	isDisabledAction = (data, code, userRole) => {
		const userLogin = localStorage.getItem('userLogin');
		const compatibleUser = (userRole === localStorage.getItem('userRole')) ? true : false;
		const compatibleCode = (data.code.includes(code)) ? true : false;
		return compatibleUser ? compatibleCode : !!userLogin
	};

	getActionButtons = (userRole) => {
		const editBtn = rowData => ({
			icon: 'editButton',
			iconProps: {style: {fontSize: '24px', color: this.isDisabledAction(rowData, 'UP.', 'SA') ? '#0d47a1' : '#ccc'}},
			tooltip: <span>Edytuj listę<span className='sr-only'> o nazwie: {rowData.name || ''}</span></span>,
			onClick: (event, rowData) => {
				this.onEditButtonClick(rowData);
			},
			disabled: !this.isDisabledAction(rowData, 'UP.', 'SA'),
		});
		const changeBtn = rowData => ({
			icon: 'autorenew',
			iconProps: {style: {fontSize: '24px', color: this.isDisabledAction(rowData, 'UP.', 'SA') ? '#0d47a1' : '#ccc'}},
			tooltip: <span>Zmień status<span className='sr-only'> o nazwie: {rowData.name || ''}</span></span>,
			onClick: (event, rowData) => {
				this.onDeactivateButtonClick(rowData);
			},
			disabled: !this.isDisabledAction(rowData, 'UP.', 'SA'),
		});
		const prevBtn = rowData => ({
			icon: 'find_in_page',
			iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
			tooltip: <span>Podgląd listy<span className='sr-only'> o nazwie: {rowData.name || ''}</span></span>,
			onClick: (event, rowData) => {
				this.onListPreviewButtonClick(rowData);
			},
		});
		const createBtn = rowData => ({
			icon: 'library_add',
			tooltip: <span>Utwórz kopię listy<span className='sr-only'> o nazwie: {rowData.name || ''}</span></span>,
			iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
			onClick: (event, rowData) => {
				this.onCopyCreateButtonClick(rowData);
			}
		});
		
		return 	userRole === 'A' || userRole === 'SA' ? 
				[editBtn, changeBtn, prevBtn, createBtn] :
				[prevBtn];
	}

	render() {
		let popUp;
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
			                title={this.state.popUp.title}
			                notification={this.state.popUp.notification}
			                link={this.state.popUp.link}
			                onClickEvent={this.state.popUp.onClickEvent}
							closePopUp={this.handleClosePopUp}
			/>) : null;
		let userRole = localStorage.getItem('userRole');
		let loadedData;
		this.state.listData ? loadedData = this.state.listData : loadedData = store.getState().lists.lists;
		let loadedProgsData;
		userRole === 'SA' ? loadedProgsData = store.getState().programs.programs : loadedProgsData = null;
		if (store.getState().programs?.selected !== null) {
			loadedData = loadedData.filter(l => l?.code?.split('.')[0] === store.getState().programs?.selected?.code);
		}
		let table;
		let button;
		let dropdown;
		if (this.props.lists && this.props.lists.isLoading === false) {
			if (loadedData.length >= 0) {
				this.prepareData(loadedData);

				table = <TableCustom
					columns={this.state.columns}
					data={loadedData}
					actions={this.getActionButtons(userRole)}
					initialPage={getTablePageBaseOnPageNumber(
						this.props.match.params.pageNumber,
						this.state.tablePageSize,
						this.props.lists.lists.length)}
					onChangePage={ 
						(page) => this.props.history.push(`/manage_lists/${parseInt(page) + 1}`)
					}
					onChangeRowsPerPage={
						(pageSize) => this.setState({tablePageSize: pageSize}) 
					}
				/>;
			}
		}


		if (userRole === 'SA' && loadedProgsData.length > 0) {
			dropdown = <div id='progs_select'>
				<SelectCustom
					labelField='code'
					placeholder='Programy'
					valueField='code'
					options={loadedProgsData}
					onChange={(values) => this.setValues(values)}
					searchFn={(selectProps) => {
						if (selectProps.state.search !== this.state.previousSearch) {
							const checkOptionCode = selectProps.props?.options?.find(spec => spec.code.toUpperCase().includes(selectProps.state?.search.toUpperCase()));
							if (!checkOptionCode) {
								selectProps.state['search'] = this.state.previousSearch;
								this.setState({});
							} else {
								this.setState({
									previousSearch: selectProps.state.search
								})
							}
						}
					}}
					multi
					isMulti
					id='programmsListSelectId'
					dropdownId='programmsListDropdownId'
					label='Programy'
					parentRef={this.programmsListSelectRef}
				/>
			</div>
		}

		return (
			<div id='list_search'>
				{popUp}
				<div id='add_list'>
					<h2 className='mb-4 float-left'>Listy sprawdzające</h2>
					{
						userRole === 'A' || userRole === 'SA' ? <Link to='/create_list' className='btn save-btn' id='plus_img_container'><i data-v-db6946bc=''
						aria-hidden='true'
						className='v-icon material-icons theme--light v-list-text'>add</i><span>UTWÓRZ LISTĘ</span></Link> :
						null
					}
					<div className='clearfix'/>
				</div>

				{userRole === 'SA' ? dropdown : null}
				<div id='questions_table'>
					{table}
					{button}
				</div>
				<div id='waiter'><Waiter loading={this.state.isWaiting || this.props.lists.isLoading}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};


const mapDispatchToProps = (dispatch) => {
	return {
		fetchListsData: () => dispatch(actions.getQuestionListData()),
		fetchProgsData: () => dispatch(actionsProg.getProgramsData())
	}
};
export const SearchListProvider = connect(mapStateToProps, mapDispatchToProps)(SearchList);
